'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapController = function MapController(Resource, growl, $http, GeojsonBuilder, $scope) {
  'ngInject';

  (0, _classCallCheck3.default)(this, MapController);
  var vm = this;
  vm.map;
  vm.markers = [];
  vm.$onInit = init;
  vm.removeAll = removeAll;
  vm.onMapClick = onMapClick;
  vm.save = save;
  vm.addToMap = addToMap;
  vm.addProtectedArea = addProtectedArea;
  vm.addManualPoint = addManualPoint;
  vm.removeManualPoint = removeManualPoint;
  vm.saveSinglePoint = saveSinglePoint;

  /**
   *
   * @param e Leaflet click event
   */
  function onMapClick(e) {
    addToMap(e.latlng.lat, e.latlng.lng);
  }

  function addManualPoint(latitude, longitude) {
    if (vm.item.geoPoints.length === vm.markers.length - 1 || vm.item.geoPoints.length === vm.markers.length) {
      vm.item.geoPoints.push({ added: false });
    }
  }

  function removeManualPoint(index) {
    var geoPoint = vm.item.geoPoints[index];
    var removedMarkers = _.remove(vm.markers, function (marker) {
      return marker.marker._latlng.lng == geoPoint.longitude && marker.marker._latlng.lat == geoPoint.latitude;
    });
    if (!_.isEmpty(removedMarkers)) {
      removedMarkers.filter(function (marker) {
        vm.map.removeLayer(marker.marker);
      });
    }
    vm.item.geoPoints.splice(index, 1);
  }

  function saveSinglePoint(point) {
    point.added = true;
    addToMap(point.latitude, point.longitude);
  }

  /**
   *
   * @param latitude
   * @param longitude
   */
  function addToMap(latitude, longitude) {
    if (_.find(vm.markers, function (el) {
      return el.marker._latlng.lat === latitude && el.marker._latlng.lng === longitude;
    })) {
      // console.log("marker già esistente", latitude, longitude)
      return false;
    }

    var marker = L.marker([latitude, longitude], {
      icon: L.icon({
        iconUrl: 'assets/img/pin.png',
        iconSize: [29.5, 40],
        iconAnchor: [15, 40]
      })
    }).addTo(vm.map);

    marker.index = vm.markers.length;
    vm.markers.push({ index: vm.markers.length, marker: marker });
    marker.on('click', function (e) {
      vm.map.removeLayer(e.target);
      _.remove(vm.markers, function (marker) {
        return marker.index === e.target.index;
      });
      _.remove(vm.item.geoPoints, function (geoPoint) {
        return geoPoint.latitude == e.latlng.lat && geoPoint.longitude == e.latlng.lng;
      });
      $scope.$apply();
    });
  }

  /**
   * Remove geo points from map
   */
  function removeAll() {
    vm.markers.filter(function (marker) {
      vm.map.removeLayer(marker.marker);
    });
    vm.markers = [];
    vm.item.geoPoints = [];
    $scope.$apply();
  }

  /**
   * Save geo points
   */
  function save() {
    var itemToSave = {};
    itemToSave[vm.model] = _.get(vm.item, vm.model);
    itemToSave.geoPoints = [];
    vm.markers.filter(function (marker) {
      var geoPoint = {
        latitude: marker.marker._latlng.lat,
        longitude: marker.marker._latlng.lng
      };
      itemToSave.geoPoints.push(geoPoint);
    });
    Resource.putGeoPoints(vm.model, itemToSave).then(function (res) {
      growl.success('Coordinate geografiche salvate con successo');
    }, function (err) {
      growl.error('Errore nel salvataggio delle coordinate geografiche');
    });
  }

  function addProtectedArea() {
    $http.get('/assets/json/area-protetta.geojson').then(function (res) {
      var geojson = L.geoJson(res.data, {
        style: {
          fillColor: 'gray',
          weight: 1,
          opacity: 1,
          color: 'blue',
          dashArray: '3,2,3',
          fillOpacity: 0.25
        }
      }).addTo(vm.map);
    });
  }

  function init() {

    console.log(_.get(vm.item, vm.model));
    console.log(vm.model);
    vm.map = L.map('map').setView([43.992642, 7.766251], 11);
    L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
      attribution: '<a href="http://openstreetmap.org">OpenStreetMap</a> | <a href="http://mapbox.com">Mapbox</a>',
      maxZoom: 21,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoibWFpbHZpcm9vcyIsImEiOiJjajlkNnJ6bnQxeDFwMnFveW9hcHJ6NGI4In0.81GT3m2HWbB2efieELsj8Q',
      zoomAnimation: true
    }).addTo(vm.map);
    vm.addProtectedArea();
    Resource.get(vm.model, _.get(vm.item, vm.model + '.id')).then(function (res) {
      vm.item.geoPoints = res.data.geoPoints;
      res.data.geoPoints.filter(function (geoPoint) {
        addToMap(geoPoint.latitude, geoPoint.longitude);
      });
    });
    var model = _.get(vm.item, vm.model);
    if (_.has(model, 'geojson')) {
      var geojson = GeojsonBuilder.getGeojson(JSON.parse(model.geojson));
      console.log(geojson);
      var jsonLayer = L.geoJSON(geojson, {
        style: {
          fillColor: 'green',
          weight: 4,
          opacity: 1,
          color: 'blue',
          dashArray: '3',
          fillOpacity: 0.8
        }
      });
      jsonLayer.addTo(vm.map);
      vm.map.fitBounds(jsonLayer.getBounds());
    }
    if (vm.model !== 'itinerary') {
      vm.map.on('click', vm.onMapClick);
    }
  }
};

exports.default = MapController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/detail/map/map.controller.js